import React, { useState, useCallback, useRef, useEffect } from 'react';
import styled from 'styled-components';
import { debounce } from 'lodash';
import { Input as BaseInput } from 'semantic-ui-react';

// The default delay that will be used if "debounce"
// property is not provided
const DEBOUNCE_DELAY = 300;

const Input = styled(BaseInput)`
    & > input {
        padding-top: 9px !important;
        padding-bottom: 9px !important;
        line-height: 18px !important;
    }
`;

function Search({ value: initialValue, onChange: onChangeProp, debounce: debounceDelay, ...props }) {
    const [value, setValue] = useState(initialValue);

    const onChangeDebounced = useRef(
        debounce((e, data) => {
            if (onChangeProp) onChangeProp(e, data);
        }, debounceDelay || DEBOUNCE_DELAY),
    );

    useEffect(() => {
        onChangeDebounced.current = debounce((e, data) => {
            if (onChangeProp) onChangeProp(e, data);
        }, debounceDelay || DEBOUNCE_DELAY);
    }, [onChangeProp, debounceDelay]);

    const onChange = useCallback((e, data) => {
        setValue(data.value);
        onChangeDebounced.current(e, data);
    }, []);

    return <Input icon="search" placeholder="Search..." {...props} value={value} onChange={onChange} />;
}

export default Search;
